import React from 'react';
import background from '../../assets/fire.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoForestfires extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="LAND"
        description="Forest fires"
        paragraph="Though fires occur naturally in many healthy forest ecosystems, man-made forest fires attributed to land clearing, subsistence farming, and rising temperatures."
        background={background}
     />
  
  );
 }
}   

export default InfoForestfires;